import React from 'react';
import { Field, Label, Control, Select } from "rbx";

const SelectField = (props) => {
  const { name, label, optionText='Selecione uma opção', value, onChange, options=[], ...other } = props;

  return (
    <Field>
      {(label) && <Label className="has-text-grey">{label}</Label>}
      <Control>
        <Select.Container color="" fullwidth>
          <Select 
            name={name} 
            value={value} 
            onChange={onChange}
            {...other}
          >
            <Select.Option value="">{optionText}</Select.Option>
            {
              options.map(
                (item, index) => (<Select.Option key={index} value={item.value}>{item.description}</Select.Option>)
              )
            }
          </Select>
        </Select.Container>
      </Control>
    </Field>
  )

}

export default SelectField;
